import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowser } from "@angular/platform-browser";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { SoAuthenticator } from "./app/utilities/soAuthenticator";

// Read by index.html's pre-bootstrap load-failure guard; set first, regardless of outcome below.
(window as any).__sofoBundleLoaded = true;

// Strip the guard's diagnostic query param so a retried load doesn't carry it into normal use.
if (window.location.search.indexOf("sofoRetry=") !== -1) {
  const url = new URL(window.location.href);
  url.searchParams.delete("sofoRetry");
  window.history.replaceState(null, "", url.toString());
}

export function getBaseUrl() {
  return document.getElementsByTagName("base")[0].href;
}

const providers = [{ provide: "BASE_URL", useFactory: getBaseUrl, deps: [] }];

if (environment === "production") {
  enableProdMode();
}

Office.initialize = (reason) => {
  if (SoAuthenticator.isAuthDialog()) {
    return;
  }

  // Angular defaults to zoneless since v21; this keeps the app on zone.js-based change detection.
  platformBrowser(providers)
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch((err) => console.error(err));
};
